module.exports = __webpack_public_path__ + "img/icon_circle_checkmark.003cd095.svg";